import { Host, h } from "@stencil/core";
export class DnnPermissionsGrid {
    constructor() {
        /** The list of users to show under the search users field when a search is performed. */
        this.foundUsers = [];
        this.selectedRoleGroupId = -1;
        this.userQuery = "";
        this.focused = false;
        this.defaultResx = {
            Add: "Add",
            AllRoles: "All Roles",
            FilterByGroup: "Filter By Group",
            GlobalRoles: "Global Roles",
            Role: "Role",
            RolePermissions: "Role Permissions",
            SelectRole: "Select Role",
            User: "User",
            UserPermissions: "User Permissions",
        };
    }
    handleFoundUsersChanged(newValue) {
        if ((newValue === null || newValue === void 0 ? void 0 : newValue.length) > 0) {
            setTimeout(() => {
                this.userCollapsible.expanded = true;
            }, 100);
        }
    }
    resxChanged() {
        this.mergeResx();
    }
    componentWillLoad() {
        document.addEventListener("click", this.dismissUserResults.bind(this));
        this.mergeResx();
    }
    disconnectedCallback() {
        document.removeEventListener("click", this.disconnectedCallback.bind(this));
    }
    mergeResx() {
        this.localResx = Object.assign(Object.assign({}, this.defaultResx), this.resx);
    }
    dismissUserResults(e) {
        const dropdownRect = this.roleDropDown.getBoundingClientRect();
        if (e.pageX > dropdownRect.right ||
            e.pageX < dropdownRect.left ||
            e.pageY > dropdownRect.bottom ||
            e.pageY < dropdownRect.top) {
            this.userCollapsible.expanded = false;
        }
    }
    handleRoleGroupChanged(dropdown) {
        const index = dropdown.selectedIndex;
        const value = Number.parseInt(dropdown.options[index].value);
        this.selectedRoleGroupId = value;
    }
    addRole() {
        const roleId = Number.parseInt(this.roleDropDown.options[this.roleDropDown.selectedIndex].value);
        const role = this.roles.filter(r => r.RoleId == roleId)[0];
        this.permissions = Object.assign(Object.assign({}, this.permissions), { rolePermissions: [
                ...this.permissions.rolePermissions,
                {
                    default: false,
                    locked: false,
                    permissions: [],
                    roleId: role.RoleId,
                    roleName: role.RoleName,
                }
            ] });
        this.permissionsChanged.emit(this.permissions);
    }
    addUser() {
        if (this.pickedUser != undefined) {
            this.permissions = Object.assign(Object.assign({}, this.permissions), { userPermissions: [
                    ...this.permissions.userPermissions,
                    {
                        displayName: this.pickedUser.displayName,
                        permissions: [],
                        userId: this.pickedUser.userId,
                    },
                ] });
            this.pickedUser = undefined;
            this.userQuery = "";
            this.permissionsChanged.emit(this.permissions);
        }
    }
    getRoles() {
        const filteredRoles = this.roles.filter(role => !this.permissions.rolePermissions.some(rp => rp.roleId == role.RoleId));
        if (this.selectedRoleGroupId == -2) {
            // All Roles
            return filteredRoles;
        }
        if (this.selectedRoleGroupId == -1) {
            // Global Roles
            return filteredRoles.filter(role => role.IsSystemRole);
        }
        return filteredRoles.filter(role => role.RoleGroupId == this.selectedRoleGroupId);
    }
    renderRoleCheckBox(rolePermission, permissionDefinition) {
        const item = rolePermission.permissions.filter(permission => permission.permissionId == permissionDefinition.permissionId)[0];
        if (rolePermission.locked) {
            return (h("svg", { xmlns: "http://www.w3.org/2000/svg", height: "24px", viewBox: "0 0 24 24", width: "24px", fill: "#000000" }, h("g", { fill: "none" }, h("path", { d: "M0 0h24v24H0V0z" }), h("path", { d: "M0 0h24v24H0V0z", opacity: ".87" })), h("path", { d: "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6zm9 14H6V10h12v10zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z" })));
        }
        const checked = item == undefined ? "intermediate" : item.allowAccess ? "checked" : "unchecked";
        return (h("label", null, h("span", { class: "hidden" }, permissionDefinition.permissionName), h("dnn-checkbox", { useIntermediate: true, nextStateHandler: state => this.handleNextState(state), checked: checked, onCheckedchange: e => this.handleRoleChanged(e.detail, rolePermission, permissionDefinition) }, h("div", { slot: "intermediateicon" }, h("svg", { xmlns: "http://www.w3.org/2000/svg", height: "24px", viewBox: "0 0 24 24", width: "24px", fill: "#000000" }, h("path", { d: "M0 0h24v24H0V0z", fill: "none" }), h("path", { d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z" }))), h("div", { slot: "uncheckedicon" }, h("svg", { xmlns: "http://www.w3.org/2000/svg", height: "24px", viewBox: "0 0 24 24", width: "24px", fill: "#000000" }, h("path", { d: "M0 0h24v24H0V0z", fill: "none" }), h("path", { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM4 12c0-4.42 3.58-8 8-8 1.85 0 3.55.63 4.9 1.69L5.69 16.9C4.63 15.55 4 13.85 4 12zm8 8c-1.85 0-3.55-.63-4.9-1.69L18.31 7.1C19.37 8.45 20 10.15 20 12c0 4.42-3.58 8-8 8z" }))))));
    }
    renderUserCheckBox(userPermission, permissionDefinition) {
        const item = userPermission.permissions.filter(permission => permission.permissionId == permissionDefinition.permissionId)[0];
        const checked = item == undefined ? "intermediate" : item.allowAccess ? "checked" : "unchecked";
        return (h("label", null, h("span", { class: "hidden" }, permissionDefinition.permissionName), h("dnn-checkbox", { useIntermediate: true, nextStateHandler: state => this.handleNextState(state), checked: checked, onCheckedchange: e => this.handleUserChanged(e.detail, userPermission, permissionDefinition) }, h("div", { slot: "intermediateicon" }, h("svg", { xmlns: "http://www.w3.org/2000/svg", height: "24px", viewBox: "0 0 24 24", width: "24px", fill: "#000000" }, h("path", { d: "M0 0h24v24H0V0z", fill: "none" }), h("path", { d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z" }))), h("div", { slot: "uncheckedicon" }, h("svg", { xmlns: "http://www.w3.org/2000/svg", height: "24px", viewBox: "0 0 24 24", width: "24px", fill: "#000000" }, h("path", { d: "M0 0h24v24H0V0z", fill: "none" }), h("path", { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM4 12c0-4.42 3.58-8 8-8 1.85 0 3.55.63 4.9 1.69L5.69 16.9C4.63 15.55 4 13.85 4 12zm8 8c-1.85 0-3.55-.63-4.9-1.69L18.31 7.1C19.37 8.45 20 10.15 20 12c0 4.42-3.58 8-8 8z" }))))));
    }
    handleNextState(state) {
        switch (state) {
            case "checked":
                return "unchecked";
            case "unchecked":
                return "intermediate";
            default:
                return "checked";
        }
    }
    handleRoleChanged(checked, rolePermission, permissionDefinition) {
        switch (checked) {
            case "unchecked":
                this.permissions = Object.assign(Object.assign({}, this.permissions), { rolePermissions: [
                        ...this.permissions.rolePermissions.map(r => {
                            if (r.roleId != rolePermission.roleId) {
                                return r;
                            }
                            const newRolePermission = Object.assign({}, r);
                            newRolePermission.permissions = [
                                ...newRolePermission.permissions.filter(p => p.permissionId != permissionDefinition.permissionId),
                                {
                                    allowAccess: false,
                                    fullControl: false,
                                    permissionCode: permissionDefinition.permissionCode,
                                    permissionId: permissionDefinition.permissionId,
                                    permissionKey: permissionDefinition.permissionKey,
                                    permissionName: permissionDefinition.permissionName,
                                    view: false,
                                },
                            ];
                            return newRolePermission;
                        }),
                    ] });
                break;
            case "checked":
                this.permissions = Object.assign(Object.assign({}, this.permissions), { rolePermissions: [
                        ...this.permissions.rolePermissions.map(r => {
                            if (r.roleId != rolePermission.roleId) {
                                return r;
                            }
                            const newRolePermission = Object.assign({}, r);
                            newRolePermission.permissions = [
                                ...newRolePermission.permissions.filter(p => p.permissionId != permissionDefinition.permissionId),
                                {
                                    allowAccess: true,
                                    fullControl: false,
                                    permissionCode: permissionDefinition.permissionCode,
                                    permissionId: permissionDefinition.permissionId,
                                    permissionKey: permissionDefinition.permissionKey,
                                    permissionName: permissionDefinition.permissionName,
                                    view: false,
                                },
                            ];
                            return newRolePermission;
                        }),
                    ] });
                break;
            case "intermediate":
                this.permissions = Object.assign(Object.assign({}, this.permissions), { rolePermissions: [
                        ...this.permissions.rolePermissions.map(r => {
                            if (r.roleId != rolePermission.roleId) {
                                return r;
                            }
                            const newRolePermission = Object.assign({}, r);
                            newRolePermission.permissions = [
                                ...newRolePermission.permissions.filter(p => p.permissionId != permissionDefinition.permissionId),
                            ];
                            return newRolePermission;
                        }),
                    ] });
                break;
            default:
                break;
        }
        this.permissionsChanged.emit(this.permissions);
    }
    handleUserChanged(checked, userPermission, permissionDefinition) {
        switch (checked) {
            case "unchecked":
                this.permissions = Object.assign(Object.assign({}, this.permissions), { userPermissions: [
                        ...this.permissions.userPermissions.map(u => {
                            if (u.userId != userPermission.userId) {
                                return u;
                            }
                            const newUserPermission = Object.assign({}, u);
                            newUserPermission.permissions = [
                                ...newUserPermission.permissions.filter(p => p.permissionId != permissionDefinition.permissionId),
                                {
                                    allowAccess: false,
                                    fullControl: false,
                                    permissionCode: permissionDefinition.permissionCode,
                                    permissionId: permissionDefinition.permissionId,
                                    permissionKey: permissionDefinition.permissionKey,
                                    permissionName: permissionDefinition.permissionName,
                                    view: false,
                                },
                            ];
                            return newUserPermission;
                        }),
                    ] });
                break;
            case "checked":
                this.permissions = Object.assign(Object.assign({}, this.permissions), { userPermissions: [
                        ...this.permissions.userPermissions.map(u => {
                            if (u.userId != userPermission.userId) {
                                return u;
                            }
                            const newUserPermission = Object.assign({}, u);
                            newUserPermission.permissions = [
                                ...newUserPermission.permissions.filter(p => p.permissionId != permissionDefinition.permissionId),
                                {
                                    allowAccess: true,
                                    fullControl: false,
                                    permissionCode: permissionDefinition.permissionCode,
                                    permissionId: permissionDefinition.permissionId,
                                    permissionKey: permissionDefinition.permissionKey,
                                    permissionName: permissionDefinition.permissionName,
                                    view: false,
                                },
                            ];
                            return newUserPermission;
                        }),
                    ] });
                break;
            case "intermediate":
                this.permissions = Object.assign(Object.assign({}, this.permissions), { userPermissions: [
                        ...this.permissions.userPermissions.map(u => {
                            if (u.userId != userPermission.userId) {
                                return u;
                            }
                            const newUserPermission = Object.assign({}, u);
                            newUserPermission.permissions = [
                                ...newUserPermission.permissions.filter(p => p.permissionId != permissionDefinition.permissionId),
                            ];
                            return newUserPermission;
                        }),
                    ] });
                break;
            default:
                break;
        }
        this.permissionsChanged.emit(this.permissions);
    }
    removeRole(rolePermission) {
        this.permissions = Object.assign(Object.assign({}, this.permissions), { rolePermissions: [
                ...this.permissions.rolePermissions.filter(rp => rp.roleId != rolePermission.roleId),
            ] });
        this.permissionsChanged.emit();
    }
    removeUser(userPermission) {
        this.permissions = Object.assign(Object.assign({}, this.permissions), { userPermissions: [
                ...this.permissions.userPermissions.filter(up => up.userId != userPermission.userId),
            ] });
        this.permissionsChanged.emit(this.permissions);
    }
    handleQueryChanged(query) {
        this.userQuery = query;
        if (query == undefined || query.length == 0) {
            this.userCollapsible.expanded = false;
            this.pickedUser = undefined;
            this.foundUsers = [];
            return;
        }
        this.userSearchQueryChanged.emit(query);
    }
    handleSearchUserFieldKeyDown(e) {
        if (e.key != "ArrowDown") {
            return;
        }
        e.preventDefault();
        const firstButton = this.userCollapsible.querySelector("button");
        if (firstButton != undefined) {
            firstButton.focus();
        }
    }
    handleSearchedUserKeyDown(e) {
        const button = e.target;
        switch (e.key) {
            case "ArrowDown":
                e.preventDefault();
                const nextButton = button.nextElementSibling;
                nextButton === null || nextButton === void 0 ? void 0 : nextButton.focus();
                break;
            case "ArrowUp":
                e.preventDefault();
                const previousButton = button.previousElementSibling;
                previousButton === null || previousButton === void 0 ? void 0 : previousButton.focus();
                break;
            default:
                break;
        }
    }
    handleUserPicked(searchedUser) {
        this.userQuery = searchedUser.displayName;
        this.pickedUser = searchedUser;
    }
    getFilteredUsers() {
        return this.foundUsers.filter(fu => !this.permissions.userPermissions.some(up => up.userId == fu.userId));
    }
    render() {
        const filteredRoles = this.getRoles();
        return (h(Host, { key: 'a2f12516da5dc5d9564007b2e76c65091d0af84c', tabIndex: this.focused ? -1 : 0, onFocus: () => this.rolesDropdown.focus(), onBlur: () => this.rolesDropdown.blur() }, h("div", { key: 'a48abe28103e12425d39d04f182bce4a8163af8a', class: "add-role-row" }, h("div", { key: '95efc48faf05b8b77362bc0460aef776e2e27d40', class: "dropdown" }, h("label", { key: 'b90793b17488cee5b232fe7bb89e3f908937da84' }, this.localResx.FilterByGroup, " :"), h("select", { key: '448ddd0ef9523f7e2bcbb0dfe0dbd75044982a53', ref: el => this.rolesDropdown = el, onChange: e => this.handleRoleGroupChanged(e.target), onFocus: () => this.focused = true, onBlur: () => this.focused = false }, h("option", { key: 'ae254c071c3717655efbd1347f9541aa751ccb65', value: -2, selected: this.selectedRoleGroupId == -2 }, this.localResx.AllRoles), h("option", { key: '8009f5a1506f02d9a82eb39915808eeda829f096', value: -1, selected: this.selectedRoleGroupId == -1 }, this.localResx.GlobalRoles), this.roleGroups.map(roleGroup => h("option", { value: roleGroup.id, selected: this.selectedRoleGroupId == roleGroup.id }, roleGroup.name)))), filteredRoles && filteredRoles.length > 0 && [
            h("div", { key: '0a99495c6743c4511e40fac14fb5e83f593b4dd8', class: "dropdown" }, h("label", { key: 'dc15f1c8aa966a9efe78edc4b708409294a0aeef' }, this.localResx.SelectRole, " :"), h("select", { key: '2da3aac53062293dc9c7b2977eb4a86f7a2fe596', ref: el => this.roleDropDown = el }, this.getRoles().map(role => h("option", { value: role.RoleId }, role.RoleName)))),
            h("dnn-button", { key: 'f628b61c9a0cf9e27b14e5659b618eef1e2ef06e', appearance: "primary", onClick: () => this.addRole() }, this.localResx.Add)
        ]), h("table", { key: '2432f74f376f904ef79e1799bde0153418f7e131', class: "roles-table" }, h("caption", { key: '982fbe85b76bcc9ecf5f320e54ce76ff25604f31' }, this.localResx.RolePermissions), h("thead", { key: 'e69b02a292f8a43a8daaefadb3a29db910468540' }, h("tr", { key: 'fe1c0575dc297313e59e6b44d3b15e661f32b6a6' }, h("th", { key: 'acdd49b31689db39b27dc1bc4af6540ea0e2fa00' }, this.localResx.Role), this.permissions.permissionDefinitions.map(permissionDefinition => h("th", null, permissionDefinition.permissionName)), h("th", { key: 'a876c7072825d2c4e1a805f0f567a4217d196a57' }, "\u00A0"))), h("tbody", { key: 'ef40137ebd42b92cdbdbf53e3b61e1b06e6e8b49' }, this.permissions.rolePermissions.map(rolePermission => h("tr", null, h("th", null, rolePermission.roleName), this.permissions.permissionDefinitions.map(permissionDefinition => h("td", null, this.renderRoleCheckBox(rolePermission, permissionDefinition))), h("td", null, !rolePermission.default &&
            h("button", { onClick: () => this.removeRole(rolePermission) }, h("svg", { xmlns: "http://www.w3.org/2000/svg", height: "24px", viewBox: "0 0 24 24", width: "24px", fill: "#000000" }, h("path", { d: "M0 0h24v24H0V0z", fill: "none" }), h("path", { d: "M14.59 8L12 10.59 9.41 8 8 9.41 10.59 12 8 14.59 9.41 16 12 13.41 14.59 16 16 14.59 13.41 12 16 9.41 14.59 8zM12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" })))))))), h("div", { key: '5717dc2a7e1e6fb2b777a9dca17095a3e76a48e9', class: "search-user" }, h("div", { key: '6dea36419a75e27b8201dd717eb599fe1e865e32', class: "search-control" }, h("dnn-searchbox", { key: '3757a79f1b5a1b0a77a82ff2b50720b1c93266f1', placeholder: this.localResx.User, onQueryChanged: e => this.handleQueryChanged(e.detail), onKeyDown: e => this.handleSearchUserFieldKeyDown(e), query: this.userQuery }), h("dnn-collapsible", { key: '55ac4f9ea3024b9c6bd10f88a40254d4df6e9f0f', ref: el => this.userCollapsible = el }, h("div", { key: 'c81d0b93d54c30c0c942f45d1b8dcff464ee17e9', class: "dropdown" }, this.getFilteredUsers().map(searchedUser => h("button", { onKeyDown: e => this.handleSearchedUserKeyDown(e), onClick: () => this.handleUserPicked(searchedUser) }, searchedUser.displayName))))), this.pickedUser &&
            h("dnn-button", { key: '52fe8c061c9b5ffa025d9593f87e9ff8a6d2ad49', onClick: () => this.addUser() }, this.localResx.Add)), this.permissions.userPermissions && this.permissions.userPermissions.length > 0 &&
            h("table", { key: '1d560e222fd38f376a22c2d879fb52ada1816349', class: "users-table" }, h("caption", { key: '61e4a6429df076579eb6bf9b2965de48c97dca56' }, this.localResx.UserPermissions), h("thead", { key: '3ff19dad3e0ab1e7dc13de5f4beb053e35af5eca' }, h("tr", { key: 'd127d6f4839eea24612ccffb74dfef1abea1e277' }, h("th", { key: '88d3e7aee4704e825a8b6908c083bcf24a5e74fe' }, this.localResx.User), this.permissions.permissionDefinitions.map(permissionDefinition => h("th", null, permissionDefinition.permissionName)), h("th", { key: '886b70eee30432b1c635a5b9b448549954d25b21' }, "\u00A0"))), h("tbody", { key: 'df1353fdcc5017c693e9603ba1e7720c144a7461' }, this.permissions.userPermissions.map(userPermission => h("tr", null, h("th", null, userPermission.displayName), this.permissions.permissionDefinitions.map(permissionDefinition => h("td", null, this.renderUserCheckBox(userPermission, permissionDefinition))), h("td", null, h("button", { onClick: () => this.removeUser(userPermission) }, h("svg", { xmlns: "http://www.w3.org/2000/svg", height: "24px", viewBox: "0 0 24 24", width: "24px", fill: "#000000" }, h("path", { d: "M0 0h24v24H0V0z", fill: "none" }), h("path", { d: "M14.59 8L12 10.59 9.41 8 8 9.41 10.59 12 8 14.59 9.41 16 12 13.41 14.59 16 16 14.59 13.41 12 16 9.41 14.59 8zM12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" }))))))))));
    }
    static get is() { return "dnn-permissions-grid"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["dnn-permissions-grid.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["dnn-permissions-grid.css"]
        };
    }
    static get properties() {
        return {
            "permissions": {
                "type": "unknown",
                "attribute": "permissions",
                "mutable": true,
                "complexType": {
                    "original": "IPermissions",
                    "resolved": "IPermissions",
                    "references": {
                        "IPermissions": {
                            "location": "import",
                            "path": "./permissions-interface",
                            "id": "src/components/dnn-permissions-grid/permissions-interface.ts::IPermissions"
                        }
                    }
                },
                "required": true,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The list of permissions."
                },
                "getter": false,
                "setter": false
            },
            "roleGroups": {
                "type": "unknown",
                "attribute": "role-groups",
                "mutable": false,
                "complexType": {
                    "original": "IRoleGroup[]",
                    "resolved": "IRoleGroup[]",
                    "references": {
                        "IRoleGroup": {
                            "location": "import",
                            "path": "./role-group-interface",
                            "id": "src/components/dnn-permissions-grid/role-group-interface.ts::IRoleGroup"
                        }
                    }
                },
                "required": true,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The list of role groups."
                },
                "getter": false,
                "setter": false
            },
            "roles": {
                "type": "unknown",
                "attribute": "roles",
                "mutable": false,
                "complexType": {
                    "original": "IRole[]",
                    "resolved": "IRole[]",
                    "references": {
                        "IRole": {
                            "location": "import",
                            "path": "./role-interface",
                            "id": "src/components/dnn-permissions-grid/role-interface.ts::IRole"
                        }
                    }
                },
                "required": true,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The list of possible roles."
                },
                "getter": false,
                "setter": false
            },
            "resx": {
                "type": "unknown",
                "attribute": "resx",
                "mutable": false,
                "complexType": {
                    "original": "ILocalization",
                    "resolved": "ILocalization | undefined",
                    "references": {
                        "ILocalization": {
                            "location": "import",
                            "path": "./localization-interface",
                            "id": "src/components/dnn-permissions-grid/localization-interface.ts::ILocalization"
                        }
                    }
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "Optionally allows localizing the component strings."
                },
                "getter": false,
                "setter": false
            },
            "foundUsers": {
                "type": "unknown",
                "attribute": "found-users",
                "mutable": false,
                "complexType": {
                    "original": "ISearchedUser[]",
                    "resolved": "ISearchedUser[]",
                    "references": {
                        "ISearchedUser": {
                            "location": "import",
                            "path": "./searched-user-interface",
                            "id": "src/components/dnn-permissions-grid/searched-user-interface.ts::ISearchedUser"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The list of users to show under the search users field when a search is performed."
                },
                "getter": false,
                "setter": false,
                "defaultValue": "[]"
            }
        };
    }
    static get states() {
        return {
            "selectedRoleGroupId": {},
            "userQuery": {},
            "pickedUser": {},
            "localResx": {},
            "focused": {}
        };
    }
    static get events() {
        return [{
                "method": "userSearchQueryChanged",
                "name": "userSearchQueryChanged",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Fires when searching for users to add to the permissions. Emits the search query."
                },
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                }
            }, {
                "method": "permissionsChanged",
                "name": "permissionsChanged",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Fires when any permissions have changed, can be used for instance to have linked permissions."
                },
                "complexType": {
                    "original": "IPermissions",
                    "resolved": "IPermissions",
                    "references": {
                        "IPermissions": {
                            "location": "import",
                            "path": "./permissions-interface",
                            "id": "src/components/dnn-permissions-grid/permissions-interface.ts::IPermissions"
                        }
                    }
                }
            }];
    }
    static get watchers() {
        return [{
                "propName": "foundUsers",
                "methodName": "handleFoundUsersChanged"
            }, {
                "propName": "resx",
                "methodName": "resxChanged"
            }];
    }
}
//# sourceMappingURL=dnn-permissions-grid.js.map
